module.exports = __webpack_public_path__ + "img/img1.41b65462.png";